import React from 'react';
import { Radio, Table } from 'antd';
import { FormOutlined, AppstoreAddOutlined, TransactionOutlined } from '@ant-design/icons';
import Withdraw from '../../components/withdraw';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';
import dayjs from  'dayjs';

const versionMap = {
    1: '基础版',
    2: '专业版',
    3: '连锁版'
}

const statusMap = {
    0: '待结算',
    1: '结算中',
    2: '已结算',
    4: '已退款',
}

const cashoutMap = {
    'PENDING': '待结算',
    'SUCCESS': '已结算',
}

export const columns = [
    {
        title: '流水号',
        dataIndex: 'flowId',
    },
    {
        title: '渠道号',
        dataIndex: 'channelNo',
    },
    {
        title: '发生时间',
        dataIndex: 'updateTime',
        render: (text, re) => <>{dayjs(re?.pay?.updateTime || re.createTime).format('YYYY-MM-DD HH:mm:ss')}</>
    },
    {
        title: '备注',
        dataIndex: 'remark',
    },
    {
        title: '状态',
        dataIndex: 'pay_status',
        // fixed: 'right',
        render: (pay_status, record) => {
            return <>{['PENDING', 'SUCCESS'].includes(record?.status) ? cashoutMap[record?.status] : statusMap[pay_status]}</>
        }
    },
    // {
    //     title: '订单金额(元)',
    //     dataIndex: 'pay.amount',
    //     render: (text, recode) => <>{recode?.pay?.amount/100}</>
    // },
    {
        fixed: 'right',
        title: '操作人',
        dataIndex: 'operator',
    },
    {
        fixed: 'right',
        title: '金额(元)',
        dataIndex: 'amount',
        render: (text) => <>{text/100}</>
    },
    // {
    //     title: '操作',
    //     fixed: 'right',
    //     render: (text, record) => {
    //         return record?.pay?.payId ? <a href={`/pay/detail?payId=${record?.pay?.payId}`}>详情</a> : null;
    //     }
    // }
];

export default () => {
    const {versionId, wdRate, cwdRate } = window.__baseInfo;
    const [payList, setPayList] = React.useState([]);
    const [summary, setSummary] = React.useState({});
    const [shopId, setShopId] = React.useState(null);
    const [pagination, setPagination] = React.useState({
        current: 1,
        pageSize: 10,
        total: 0,
        simple: true,
        showSizeChanger: false,
    });

    // 获取订单列表
    const getOrderList = async (params) => {
        params = params || { page : 1 , pageSize: 10};
        let urlParams = new URLSearchParams();
        const shopId = await getCurrentShopId();
        urlParams.append('shopId', shopId);

        Object.keys(params).forEach(key => {
            if(params[key]) urlParams.append(key, params[key]);
        });
        
        const response = await fetch(`/api/finance/funding-flow-invite?${urlParams.toString()}`);
        return await response.json();
    }

    const reloadData = async (params) => { 
        getOrderList(params).then(res => {
            setPayList(res?.data?.rows || []);
            setPagination({
                ...pagination, 
                current: params?.page || 1, 
                total: res?.data?.count || 0,
                pageSize: params?.pageSize || 10,
            });
        });
    }

    const loadShopSummary = async () => {
        const shopId = await getCurrentShopId();

        getShopSummary(shopId).then(res => {
            setSummary(res.data);
        });
    }

    const getShopSummary = async (shopId) => {
        const res = await fetch(`/api/finance/fund-summary-invite?shopId=${shopId}`);
        const result = await res.json();
        return result;
    }


    const onTableChange = (pagination) => {
        console.log('pagination', pagination);
        const {current, pageSize} = pagination;
        reloadData({page: current, pageSize});
        // setPagination(pagination);
    };

    React.useEffect(() => {
        reloadData();
        loadShopSummary();
    }, []);

    return (
        <div>
            <SwitchShop />
            <h2 className="admin-page-title">资金流水</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mb-4">
                <div className="admin-card p-4">
                    <div className="text-sm text-text-secondary mb-1">余额</div>
                    <div className="text-xl font-semibold text-green-600">¥{(summary.totalAmount/100).toFixed(2)}</div>
                </div>

                <div className="admin-card p-4">
                    <div className="text-sm text-text-secondary mb-1">可提现</div>
                    <div className="text-xl font-semibold text-green-600">¥{((summary.withdrawAmount - summary.pendingAmount + summary.pendingAmount)/100).toFixed(2)}</div>
                </div>

                <div className="admin-card p-4">
                    <div className="text-sm text-text-secondary mb-1">待入账</div>
                    <div className="text-xl font-semibold text-green-600">¥{(summary.frozenAmount/100).toFixed(2)}</div>
                </div>
            </div>
            <Withdraw 
                className="mb-4"
                maxAmount={(summary.withdrawAmount - summary.pendingAmount)/100}
                disabled={summary.withdrawAmount - summary.pendingAmount <= 0}
                type="invite"
            />
            
            <div className="admin-card p-4 mb-4">
                <h3 className="admin-section-title mb-3">账户信息</h3>
                <div className="space-y-2 text-sm">
                    <div>版本：{versionMap[versionId]}</div>
                    <div>提现费率：{cwdRate * 100}% (<span className="line-through text-text-tertiary">{wdRate * 100}%</span>)</div>
                    <div>提现方式：{versionId === 1 ? '手动提现': '自动提现'}</div>
                </div>
            </div>
            <Table size='small' 
                pagination={pagination} 
                rowKey={'flowId'} 
                columns={columns} 
                dataSource={payList} 
                scroll={{ x: 'max-content' }}
                onChange={onTableChange}
            />
        </div>
    );
};

const Months = ({onChange}) => { 
    const [yearMonth, setYearMonth] = React.useState(undefined);
    // 当前月及之前6个月
    const months = Array.from({length: 6}, (v, k) => {
        const date = new Date();
        date.setMonth(date.getMonth() - k);
        const ym = dayjs(date).format('YYYYMM');
        return {label: `${date.getMonth() + 1}`, value: ym};
    });

    months.unshift({ label: '全部', value: undefined });

    const onOptionChange = (value) => {
        setYearMonth(value);
        onChange?.(value);
    }

    return (
        <div style={{ marginBottom: 10}}>
            <div>按月查看{yearMonth !== undefined && <span>(已结算)</span>}</div>
            <Radio.Group options={months} optionType='button' onChange={(e) => onOptionChange?.(e.target.value)} />月
        </div>
    )
};